import store from './store';

const addClickOutsideListener = (el, binding) => {
    const clickEventHandler = event => {
        if (binding.value && binding.value.item === 'burgerMenu') {
            const exists = event.composedPath().some(
                path =>
                    path.id === 'sidebar' ||
                    path.id === 'burger-menu'
            );

            if (
                store.getters.mobileMenuVisible &&
                !el.contains(event.target) &&
                el !== event.target &&
                !exists
            ) {
                binding.value.fn(event);
            }
        } else {
            const exceptionElemId = binding.arg;
            
            if (
                !el.contains(event.target) &&
                el !== event.target &&
                !(
                    exceptionElemId &&
                    event.target.closest(`#${exceptionElemId}`)
                )
            ) {
                binding.value(event);
            }
        }
    };

    el.__vueClickEventHandler__ = clickEventHandler;
    document.addEventListener('click', clickEventHandler);
};

const removeClickOutsideListener = el => {
    document.removeEventListener('click', el.__vueClickEventHandler__);
    delete el.__vueClickEventHandler__;
};

export const clickOutside = {
    // Vue 2
    bind: addClickOutsideListener,
    unbind: removeClickOutsideListener,

    // Vue 3
    mounted: addClickOutsideListener,
    unmounted: removeClickOutsideListener
};

const focusElement = (el) => {
    const target = el.matches('input, textarea, select')
        ? el
        : el.querySelector('input, textarea, select');
    target?.focus();
};

export const focus = {
    // Vue 2
    inserted(el) {
        focusElement(el);
    },
    // Vue 3
    mounted(el) {
        focusElement(el);
    }
};